var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgGlobal = function SvgGlobal(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 97,
    height: 96,
    viewBox: "0 0 97 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_261_34517)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.7815 82.7687C31.6628 82.7687 31.5045 82.8479 31.3857 82.8479C23.7065 79.0479 17.4524 72.7542 13.6128 65.075C13.6128 64.9562 13.692 64.7979 13.692 64.6792C18.5211 66.1042 23.5086 67.1729 28.4565 68.0042C29.3274 72.9917 30.3565 77.9396 31.7815 82.7687Z",
    fill: "url(#paint0_linear_261_34517)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.3877 65.1146C80.4689 72.9917 73.9377 79.3646 65.9814 83.2042C67.4856 78.1771 68.7523 73.1104 69.5835 68.0042C74.571 67.1729 79.4794 66.1042 84.3085 64.6792C84.2689 64.8375 84.3877 64.9958 84.3877 65.1146Z",
    fill: "url(#paint1_linear_261_34517)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.7044 30.5187C79.7169 29.0146 74.6898 27.7875 69.5835 26.9167C68.7523 21.8104 67.5252 16.7437 65.9814 11.7958C74.1752 15.7146 80.7856 22.325 84.7044 30.5187Z",
    fill: "url(#paint2_linear_261_34517)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.7811 12.2312C30.3561 17.0604 29.3269 21.9687 28.4957 26.9562C23.3894 27.7479 18.3227 29.0146 13.2957 30.5187C17.1352 22.5625 23.5082 16.0312 31.3852 12.1125C31.504 12.1125 31.6623 12.2312 31.7811 12.2312Z",
    fill: "url(#paint3_linear_261_34517)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.8147 26.0854C53.6314 25.0563 44.3689 25.0563 35.1855 26.0854C36.1751 20.6625 37.4418 15.2396 39.223 10.0146C39.3022 9.69792 39.2626 9.46042 39.3022 9.14375C42.4293 8.39167 45.6355 7.91667 49.0001 7.91667C52.3251 7.91667 55.571 8.39167 58.6585 9.14375C58.698 9.46042 58.698 9.69792 58.7772 10.0146C60.5585 15.2792 61.8251 20.6625 62.8147 26.0854Z",
    fill: "url(#paint4_linear_261_34517)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.5855 61.3146C22.123 60.325 16.7397 59.0583 11.5147 57.2771C11.198 57.1979 10.9605 57.2375 10.6438 57.1979C9.89175 54.0708 9.41675 50.8646 9.41675 47.5C9.41675 44.175 9.89175 40.9291 10.6438 37.8416C10.9605 37.8021 11.198 37.8021 11.5147 37.7229C16.7792 35.9812 22.123 34.675 27.5855 33.6854C26.5959 42.8687 26.5959 52.1312 27.5855 61.3146Z",
    fill: "url(#paint5_linear_261_34517)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.5831 47.5C88.5831 50.8646 88.1081 54.0708 87.356 57.1979C87.0393 57.2375 86.8018 57.1979 86.4851 57.2771C81.2206 59.0187 75.8372 60.325 70.4143 61.3146C71.4435 52.1312 71.4435 42.8687 70.4143 33.6854C75.8372 34.675 81.2601 35.9416 86.4851 37.7229C86.8018 37.8021 87.0393 37.8416 87.356 37.8416C88.1081 40.9687 88.5831 44.175 88.5831 47.5Z",
    fill: "url(#paint6_linear_261_34517)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.8147 68.9146C61.8251 74.3771 60.5585 79.7604 58.7772 84.9854C58.698 85.3021 58.698 85.5396 58.6585 85.8563C55.571 86.6083 52.3251 87.0833 49.0001 87.0833C45.6355 87.0833 42.4293 86.6083 39.3022 85.8563C39.2626 85.5396 39.3022 85.3021 39.223 84.9854C37.4814 79.7208 36.1751 74.3771 35.1855 68.9146C39.7772 69.4292 44.3689 69.7854 49.0001 69.7854C53.6314 69.7854 58.2626 69.4292 62.8147 68.9146Z",
    fill: "url(#paint7_linear_261_34517)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.8966 62.3965C53.9964 63.6456 44.0037 63.6456 34.1036 62.3965C32.8545 52.4963 32.8545 42.5036 34.1036 32.6035C44.0037 31.3544 53.9964 31.3544 63.8966 32.6035C65.1457 42.5036 65.1457 52.4963 63.8966 62.3965Z",
    fill: "url(#paint8_linear_261_34517)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_261_34517",
    x1: 22.6327,
    y1: 67.1249,
    x2: 23.1516,
    y2: 82.8329,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BDE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E3F2FD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_261_34517",
    x1: 75.1193,
    y1: 67.1729,
    x2: 75.6517,
    y2: 83.1886,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BDE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E3F2FD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_261_34517",
    x1: 75.2765,
    y1: 14.3162,
    x2: 75.8112,
    y2: 30.5033,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BDE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E3F2FD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_261_34517",
    x1: 22.4728,
    y1: 14.5903,
    x2: 22.9962,
    y2: 30.5037,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BDE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E3F2FD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_261_34517",
    x1: 48.9022,
    y1: 10.3625,
    x2: 49.2435,
    y2: 26.0801,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BDE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E3F2FD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_261_34517",
    x1: 18.4367,
    y1: 37.4047,
    x2: 19.6348,
    y2: 61.2576,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BDE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E3F2FD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_261_34517",
    x1: 79.4343,
    y1: 37.4047,
    x2: 80.6323,
    y2: 61.2576,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BDE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E3F2FD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_261_34517",
    x1: 48.9022,
    y1: 71.3604,
    x2: 49.2435,
    y2: 87.0781,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BDE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E3F2FD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_261_34517",
    x1: 48.8878,
    y1: 35.9295,
    x2: 49.7921,
    y2: 63.3072,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BDE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E3F2FD"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_261_34517"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 96,
    height: 96,
    fill: "white",
    transform: "translate(0.5)"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgGlobal);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "global.cb88db48df6cd7479fae2684ca9493f7.svg";